/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import { makeStyles, ThemeProvider } from '@material-ui/core/styles'

import Header from "../Header"
import Footer from '../Footer'
import theme from '../../utils/theme'
import colors from '../../variables/colors'
import './Layout.css'

const useStyles = makeStyles({
  root: {
    backgroundColor: colors.background.primary
  },
  container: {
    // marginTop: '56px',
    padding: 0
  },
  background1: {
    height: '80px',
    backgroundRepeat: 'repeat',
    backgroundSize: 'auto',
    marginTop: '65px !important'
  },
  button: {
    position: 'fixed',
    bottom: '20px',
    right: '20px'
  },
  footer: {
  },
  '@media screen and (min-width: 599px)': {
    container: {
      // marginTop: '65px'
    }
  }
})

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          location
          telephone
        }
      }
    }
  `)
  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <Box className={classes.root}>
        <header>
          <Header siteMetaData={data.site.siteMetadata} />
        </header>
        <Container className={classes.container} maxWidth="xl">
          <main>{children || ''}</main>
        </Container>
        <footer className={classes.footer}>
          <Footer />
        </footer>
      </Box>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
